<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('detail')"></pageTitle>
        <myDetailCell :info="labels" :title="$t('school.change_profile')">
          <template v-slot:salary="{ data }">
            <div v-if="info.part == 1">
              <div class="demo-upload-list" v-for="(item, i) in data.value" :key="i">
                <template>
                  <img :src="item.file_lnk" />
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.file_lnk) "></Icon>
                  </div>
                </template>
              </div>
            </div>
            <div v-else class="datum">
              <div class="datum_item">
                <div class="name">{{ $t("school_record.name") }}:</div>
                <div class="con">{{ data.value.en_cname }}</div>
              </div>
              <div class="datum_item">
                <div class="name">{{ $t("school.desc") }}:</div>
                <div class="con">{{ data.value.en_cdesc }}</div>
              </div>
              <div class="datum_item">
                <div class="name">{{ $t("school.address") }}:</div>
                <div class="con">{{ data.value.en_addr }}</div>
              </div>
              <div class="datum_item">
                <div class="name">{{ $t("school.image") }}:</div>
                <div class="con">
                  <div class="demo-upload-list" v-if="data.value.en_avartar">
                    <template>
                      <img :src="data.value.en_avartar" />
                      <div class="demo-upload-list-cover">
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(data.value.en_avartar)"
                        ></Icon>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </myDetailCell>

        <Row justify="end" class="mg-top20">
          <Col>
            <Button class="mg-right20" @click="$base.linkBack()">{{ $t("back") }}</Button>
            <Poptip
              v-if="info.roll_back == 1"
              confirm
              :title="$t('confirm_revert')"
              @on-ok="handleSubmit()"
            >
              <Button type="primary">{{ $t("revert") }}</Button>
            </Poptip>
          </Col>
        </Row>
      </div>
    </div>
    <Modal :title="$t('view_img')" v-model="visible">
      <img :src="imgName" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>

<script>
import myDetailCell from "@/components/myDetailCell";
import pageTitle from "@/components/pageTitle";
export default {
  name: "recruit_detail",
  components: {
    myDetailCell,
    pageTitle
  },
  data () {
    return {
      id: this.$base.getRequest().id,
      labels: [],
      imgName: "",
      visible: false,
      info: {}
    };
  },
  mounted () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this.$base.showLoading();
      this.$request.sendPost(
        "school-profile/before-upd",
        { log_id: this.id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.info = data.info;
          let cur_version = this.info.cur_version == '' ? {} : JSON.parse(this.info.cur_version);
          this.labels = [
            {
              label: this.$t("school_record.id"),
              value: this.info.school_id
            },
            {
              label: this.$t("school_record.name"),
              value: this.info.school_cname
            },
            {
              label: this.$t("school.last_modified"),
              value: this.info.part_cdesc
            },
            {
              label: this.$t("school.change_content"),
              value: cur_version,
              slot: "salary"
            }
          ];
        }
      );
    },
    handleSubmit () {
      this.$base.showLoading();
      this.$request.sendPost(
        "school-profile/back",
        { log_id: this.id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$base.linkBack();
        }
      );
    },
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .datum {
    .datum_item {
      display: flex;
      padding: 10px 0;
      .name {
        margin-right: 10px;
      }
    }
  }
  .salary {
    padding-left: 8px;
    display: flex;
    align-items: center;
  }
  .hkd {
    margin-top: 1px;
  }
  .demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/profile/profile_detail.vue